import axios from "axios"
import {Message} from 'element-ui'

let baseURL = "http://www.swicpub.com/";
if(process.env.NODE_ENV=="development"){
  baseURL = "http://192.168.3.188:8087/";
  // 开发
  console.log('开发');
}else if(process.env.NODE_ENV=="production"){
// 生产
console.log('生产');
  baseURL = location.origin+'/pubsh'

}else{
  // 本地
  console.log('本地');
  baseURL = "http://www.swicpub.com/"
}


//设置跨域请求
axios.defaults.withCredentials = true;
axios.defaults.timeout = 10000;
axios.defaults.baseURL = baseURL;
axios.defaults.headers = { "Content-Type": "application/json;charset=UTF-8" };
// axios.defaults.headers = { "Content-Type": "multipart/form-data" };


// request 拦截器   请求拦截
axios.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem('token');
    if(token){
      config.headers['token'] = token;
    }
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);


// response 拦截器  响应拦截
axios.interceptors.response.use(
  (response) => {
    // console.log(response);
    let data = response.data||response;
    return data;
  },
  function(error) {
    // console.dir(error);
    if (error.response) {
      // switch ( error.response.status ) {
        // case 401:
        // 返回 401 清除token信息并跳转到登录页面
        // localStorage.removeItem("Authorization"); //清空
        // router.replace({
        //   path: "Login",
        // });
      // }
    }else{
      Message({
        message:'网络错误',
        type:'warning'
      })
    }
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export function post(url, params={}) {
  // let fd = new FormData()
  // for(let name in params){
  //   fd.append(name,params[name])
  // }

  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function get(url, params={}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {params})
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export default baseURL;
